export const my = {
    name: "Kelly J. Davis",
    data: {
        github: "https://github.com/kdgiddyup",
        linkedin: "https://www.linkedin.com/in/kellyjdavis/",
        facebook: "http://facebook.com/kdavis1974",
        web: "http://kellyjdavis.com",
        email: "kellydavis1974@gmail.com",
        address: "Bluffton, SC",
        phone: "803-319-9831"
    }
};